import React from 'react'
import { parse } from 'date-fns'
import {
  CartMenuItemList,
  CartSubtotal,
  CartSubtotalPosttax,
  CartSubtotalPretax,
  CartTotal
} from '../cart/Cart'
import {
  Location,
  LocationContainer,
  LocationLogo,
  LocationTime,
  LocationBuilding,
  LocationOrderStatus
} from './Location'
import { convertOrderDetailItemsToCartMenuItems } from '../../util/formatUtils'

export const OrderDetails = ({
  order,
  favorites,
  addFavoriteStart,
  deleteFavoriteStart
}) => {
  const menuItems = convertOrderDetailItemsToCartMenuItems(order.orderItems)
  return (
    <div className="cart">
      <div className="location">
        <div className="location-content_row">
          <div className="location-order">
            <span className="location-order_icon">
              <i className="icon-cart" />
            </span>
            <span className="location-order_number">
              Order: {order.orderId}
            </span>
          </div>
          <div className="location-order">
            <span className="location-order_icon">
              <i className="icon-user" />
            </span>
            <span className="location-order_number">
              Name: {order.username}
            </span>
          </div>
          {order.ccLastFour ? (
            <div className="location-order">
              <span className="location-order_icon">
                <i className="icon-credit-card" />
              </span>
              <span className="location-order_number">
                CC Used: {order.ccLastFour}
              </span>
            </div>
          ) : null}
        </div>
      </div>
      <CartMenuItemList
        menuItems={menuItems}
        dropoffId={order.deliveryDropoffId}
        editable={false}
        showEditLinks={false}
        favorites={favorites}
        menuId={order.menuId}
        addFavoriteStart={addFavoriteStart}
        deleteFavoriteStart={deleteFavoriteStart}
        collapsible
        useFullSubTotal
      />
      <hr />
      <div className="row middle-xs">
        <div className="col-xs-12 col-md-6">
          <div className="col-xs-12 center-xs">
            <button
              className="tertiary cart-checkout"
              media="print"
              onClick={() => window.print()}
            >
              <i className="icon-printer" /> Print Receipt
            </button>
          </div>
        </div>
        <div className="col-xs-12 col-md-6">
          <CartSubtotal>
            <CartSubtotalPretax
              subtotal={order.preTaxSubTotal}
              deliveryFee={order.foodsbyFee}
              couponApplied={order.couponId != null && !order.isCouponEpp}
              couponCode={order.couponCode}
              couponAmount={order.couponSubTotal}
              creditsApplied={order.creditSubTotal > 0}
              creditsUsed={order.creditSubTotal}
            />
            <hr />
            <CartSubtotalPosttax
              taxes={order.taxTotal}
              programApplied={order.couponId != null && order.isCouponEpp}
              programCode={order.couponCode}
              programAmount={order.couponSubTotal}
            />
          </CartSubtotal>
          <CartTotal total={order.orderTotal} totalTitle={'Total:'} />
        </div>
      </div>
    </div>
  )
}

export const OrderSummaryLocation = ({ order, orderHistorySize }) => {
  return (
    <Location>
      <LocationContainer>
        <div className="row middle-xs">
          <div className="col-xs-12 col-md-4">
            <LocationLogo
              logoLink={order.logoUrl}
              logoAlt={order.storeName + ' Logo'}
            />
          </div>
          <div className="col-xs-12 col-md-8">
            <h1>
              <LocationOrderStatus
                order={order}
                statusText={order.statusText}
                locationStatusClasses="loc-three-row"
                extraClasses={
                  !orderHistorySize
                    ? { confirm: true }
                    : { orderHistoryStatus: true }
                }
              />
            </h1>
            <LocationBuilding
              name={order.locationName}
              address={order.address}
            />
            <LocationTime
              multiLine={false}
              dateTime={parse(order.deliveryDateTime)}
            />
          </div>
        </div>
      </LocationContainer>
    </Location>
  )
}

export const OrderSummary = ({ children }) => <div>{children}</div>

export default OrderSummary
